module.exports = __webpack_public_path__ + "media/select_game_or_tutorial.d18f9df7.mp3";